import React, { useContext, useEffect, useState } from "react";
import { 
  ButtonGroup, 
  FormErrorMessage, 
  Spacer, 
  Text, 
  FormControl, 
  FormLabel, 
  Select, 
  NumberInput, 
  NumberInputField, 
  NumberInputStepper, 
  NumberIncrementStepper, 
  NumberDecrementStepper, 
  Input, 

  Textarea,
  Icon,
  HStack
} from "@chakra-ui/react";
import { FiTruck, FiDollarSign, FiPercent, FiFileText } from "react-icons/fi";
import { ModalButton } from "./buttons/ModalButton";
import AuthContext from "../contexts/Auth";
import client from "../helpers/Client";

const basePriceFormat = (val) => `$` + val;
const discountFormat = (val) => `%` + val;

function ServiceActions({
  handleSendToReseller,
  setSelectedCovared,
  setSelectedCargo,
  handleAccept,
  handleRejected,
  setSentToBaseTrackingNumber,
  setBasePrice,
  setPrice,
  setServiceDesc,
  price,
  setDiscount,
  basePrice,
  discount,
  handleDelete,
  handleSendToBase,
  handleReceivedByBase,
  handleReceivedByReseller,
  handleEvalCompleted,
  handleEvalStarted,
  handleReset,
  service,
  children,
  handleComplated,
  handleFailed,
  errorData,
  ...props
}) {
  const auth = useContext(AuthContext);
  const isSuperUser = !!auth?.data?.user?.is_superuser;
  const userRoles = {
    manager: !!auth?.data?.user?.employee?.is_manager,
    servicer: !!auth?.data?.user?.is_servicer,
    technical: !!auth?.data?.user?.is_technical,
    reseller: !!auth?.data?.user?.is_reseller,
    employee: !!auth?.data?.user?.is_employee,
  };
  const [disabledButtons, setDisabledButtons] = useState(new Set());
  useEffect(() => {
    const load = async () => {
      try {
        if (isSuperUser) { setDisabledButtons(new Set()); return; }
        const roles = Object.entries(userRoles).filter(([_, v]) => v).map(([k]) => k);
        if (!roles.length) { setDisabledButtons(new Set()); return; }
        const { data } = await client.get(`/config/role-pages/?enabled=false`);
        const arr = Array.isArray(data?.results) ? data.results : (Array.isArray(data) ? data : []);
        const disabled = arr.filter(it => roles.includes(it.role_code) && it.button_id).map(it => it.button_id);
        setDisabledButtons(new Set(disabled));
      } catch (_) {
        setDisabledButtons(new Set());
      }
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuperUser]);
  const allow = (id) => isSuperUser || !disabledButtons.has(id);
  
  // Color mode values
  const labelColor = "gray.700";
  const inputBg = "white";
  const borderColor = "gray.200";
  const hoverBorderColor = "blue.300";
  return (
    <ButtonGroup direction="row" display="flex" {...props}>
      {!service.sent_to_base_at && (
        <ModalButton label="Servise Gönderildi" callback={handleSendToBase} actionLabel={'Kaydet'} handleReset={handleReset}>
          <FormControl mb={4}>
            <FormLabel color={labelColor} fontWeight="semibold">
              <HStack spacing={2}>
                <Icon as={FiTruck} />
                <Text>Kargo Şirketi</Text>
              </HStack>
            </FormLabel>
            <Select 
              onChange={(e) => setSelectedCargo(e.target.value)}
              bg={inputBg}
              border="2px"
              borderColor={borderColor}
              _hover={{
                borderColor: hoverBorderColor,
              }}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px #3182ce",
              }}
            >
              <option value="">Kargo şirketi seçiniz</option>
              <option value={"MNG"}>MNG Kargo</option>
              <option value={"ARAS"}>Aras Kargo</option>
              <option value={"YURTICI"}>Yurtiçi Kargo</option>
              <option value={"SURAT"}>Sürat Kargo</option>
              <option value={"PTT"}>PTT Kargo</option>
              <option value={"UPS"}>UPS Kargo</option>
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel color={labelColor} fontWeight="semibold">
              Kargo Takip Numarası
            </FormLabel>
            <Input
              placeholder="Kargo takip numarasını giriniz"
              onChange={(e) => setSentToBaseTrackingNumber(e.target.value)}
              bg={inputBg}
              border="2px"
              borderColor={borderColor}
              _hover={{
                borderColor: hoverBorderColor,
              }}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px #3182ce",
              }}
            />
          </FormControl>
        </ModalButton>
      )}
      {service.sent_to_base_at && !service.received_by_base_at && auth.data.user.is_servicer && (
        <ModalButton label="Servise Ulaştı" callback={handleReceivedByBase} handleReset={handleReset} isVisible={allow('service.action.received_by_base')}>
          <Text>Ürünün başarılı bir şekilde servise ulaştığını onaylıyor musunuz?</Text>
        </ModalButton>
      )}
      {service.received_by_base_at && !service.eval_started_at && auth.data.user.is_servicer && (
        <ModalButton label="İncelemeye Al" callback={handleEvalStarted} handleReset={handleReset} isVisible={allow('service.action.eval_started')}>
          <Text>Ürünün incelemeye alındı mı?</Text>
        </ModalButton>
      )}
      {service.eval_started_at && !service.eval_completed_at && auth.data.user.is_servicer && (
        <ModalButton label="Servis Tutarı Belirle" callback={handleEvalCompleted} actionLabel='Kaydet' handleReset={handleReset} isVisible={allow('service.action.eval_completed')}>
          <FormControl mb={2} isRequired isInvalid={errorData.covered_by !== undefined}>
            <FormLabel color={labelColor} fontWeight="semibold">
              Servis Tutarı Karşılayan
            </FormLabel>
            <Select 
              onChange={(e) => setSelectedCovared(e.target.value)}
              bg={inputBg}
              border="2px"
              borderColor={borderColor}
              _hover={{
                borderColor: hoverBorderColor,
              }}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px #3182ce",
              }}
            >
              <option value="">Seçiniz</option>
              <option value={"customer"}>Müşteri</option>
              <option value={"reseller"}>Bayi</option>
              <option value={"guarantee"}>Garanti</option>
            </Select>
            {errorData.covered_by?.map((message) => (<FormErrorMessage>{message}</FormErrorMessage>))}
          </FormControl>
          <FormControl mb={2} isRequired>
            <FormLabel color={labelColor} fontWeight="semibold">
              <HStack spacing={2}>
                <Icon as={FiDollarSign} />
                <Text>Servis Ücreti</Text>
              </HStack>
            </FormLabel>
            <NumberInput 
              onChange={(newValue) => { setBasePrice(newValue); }} 
              value={basePriceFormat(basePrice)}
            >
              <NumberInputField 
                bg={inputBg}
                border="2px"
                borderColor={borderColor}
                _hover={{
                  borderColor: hoverBorderColor,
                }}
                _focus={{
                  borderColor: "blue.500",
                  boxShadow: "0 0 0 1px #3182ce",
                }}
              />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
            {errorData.base_price?.map((message) => (<FormErrorMessage>{message}</FormErrorMessage>))}
          </FormControl>
          <FormControl mb={2} isRequired>
            <FormLabel color={labelColor} fontWeight="semibold">
              <HStack spacing={2}>
                <Icon as={FiPercent} />
                <Text>İskonto</Text>
              </HStack>
            </FormLabel>
            <NumberInput 
              onChange={(newValue) => { setDiscount(newValue); }} 
              value={discountFormat(discount)}
            >
              <NumberInputField 
                bg={inputBg}
                border="2px"
                borderColor={borderColor}
                _hover={{
                  borderColor: hoverBorderColor,
                }}
                _focus={{
                  borderColor: "blue.500",
                  boxShadow: "0 0 0 1px #3182ce",
                }}
              />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
            {errorData.discount_ratio?.map((message) => (<FormErrorMessage>{message}</FormErrorMessage>))}
          </FormControl>
          <FormControl mb={2}>
            <FormLabel>Net Tutar</FormLabel>
            <Input value={price} type="number" isDisabled />
          </FormControl>
          <FormControl mb={2} isRequired isInvalid={errorData.service_desc !== undefined}>
            <FormLabel color={labelColor} fontWeight="semibold">
              <HStack spacing={2}>
                <Icon as={FiFileText} />
                <Text>Yapılacak İşlem(lerin) Açıklaması</Text>
              </HStack>
            </FormLabel>
            <Textarea 
              onChange={(e) => setServiceDesc(e.target.value)}
              bg={inputBg}
              border="2px"
              borderColor={borderColor}
              _hover={{
                borderColor: hoverBorderColor,
              }}
              _focus={{
                borderColor: "blue.500",
                boxShadow: "0 0 0 1px #3182ce",
              }}
              placeholder="Servis açıklamasını giriniz..."
              resize="vertical"
              minH="100px"
            />
            {errorData.service_desc?.map((message) => (<FormErrorMessage>{message}</FormErrorMessage>))}
          </FormControl>
        </ModalButton>
      )}
      {service.eval_completed_at && !service.coverage_accepted_at && auth.data.user.is_servicer && (
        <ModalButton label="Ücret Onaylandı" callback={handleAccept} handleReset={handleReset} isVisible={allow('service.action.coverage_accept')}>
          <Text>Ücretin kabul edildiğini onaylıyor musunuz?</Text>
        </ModalButton>
      )}
      {service.eval_completed_at && !service.coverage_accepted_at && auth.data.user.is_servicer && (
        <ModalButton label="Reddedildi" callback={handleRejected} handleReset={handleReset} isVisible={allow('service.action.coverage_reject')}>
          <Text>Ücretin reddedildiğini onaylıyor musunuz?</Text>
        </ModalButton>
      )}
      {service.coverage_accepted_at && !service.sent_to_reseller_at && auth.data.user.is_servicer && (
        <ModalButton label="Bayiye Gönderildi" callback={handleSendToReseller} actionLabel='Kaydet' handleReset={handleReset} isVisible={allow('service.action.send_to_reseller')}>
          <Select mb={5} onChange={(e) => setSelectedCargo(e.target.value)}>
            <option selected hidden disabled value="">Kargo Şirketi</option>
            <option value={"MNG"}>MNG Kargo</option>
            <option value={"ARAS"}>Aras Kargo</option>
            <option value={"YURTICI"}>Yurtiçi Kargo</option>
            <option value={"SURAT"}>Sürat Kargo</option>
            <option value={"PTT"}>PTT Kargo</option>
            <option value={"UPS"}>UPS Kargo</option>
          </Select>
          <Input
            placeholder={"kargo takip"}
            onChange={(e) => setSentToBaseTrackingNumber(e.target.value)}
          ></Input>
        </ModalButton>
      )}
      {service.sent_to_reseller_at && !service.received_by_reseller_at && !auth.data.user.is_servicer && (
        <ModalButton label="Teslim Alındı" callback={handleReceivedByReseller} handleReset={handleReset} isVisible={allow('service.action.received_by_reseller')}>
          <Text>Ürünün bayi tarafından teslim alındığını onaylıyor musunuz?</Text>
        </ModalButton>
      )}
      {service.received_by_reseller_at && !service.failed_at && !service.completed_by && !auth.data.user.is_servicer && (
        <ModalButton label="Ürün Çalıştı" callback={handleComplated} handleReset={handleReset} isVisible={allow('service.action.completed')}>
          <Text>Ürünün artık çalışır durumda olduğunu onaylıyor musunuz?</Text>
        </ModalButton>
      )}
      {service.received_by_reseller_at && !service.failed_at && !service.completed_by && !auth.data.user.is_servicer && (
        <ModalButton label="Ürün Çalışmadı" callback={handleFailed} handleReset={handleReset} isVisible={allow('service.action.failed')}>
          <Text>Ürünün servis görmesine rağmen hala çalışmadığını onaylıyor musunuz?</Text>
        </ModalButton>
      )}
      <Spacer />
      {children}
    </ButtonGroup>
  );
}

export default ServiceActions;
